export const ADD_TEST_SCORE = 'ADD_TEST_SCORE';
export const DELETE_TEST_SCORE = 'DELETE_TEST_SCORE';
export const ADD_STUDENT_TEST_SCORE = 'ADD_STUDENT_TEST_SCORE';
export const DELETE_STUDENT_TEST_SCORE = 'DELETE_STUDENT_TEST_SCORE';

export const ADD_SCORE = 'ADD_SCORE';
export const DELETE_SCORE = 'DELETE_SCORE';
export const ADD_STUDENT_SCORE = 'ADD_STUDENT_SCORE';
export const DELETE_STUDENTT_SCORE = 'DELETE_STUDENTT_SCORE';